import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const url = "http://webstorage3.innpressionhost.com/backend/request.php";

const options = { headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded') };

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  UploadImage(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('upload_base64_file_to_server', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  AdminLogin(username, password): Promise<any> {
    let body = new URLSearchParams();
    body.set('admin_login', JSON.stringify({username: username, password: password}));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  GetAllDataByDataType(data_type): Promise<any> {
    let body = new URLSearchParams();
    body.set('get_all_data_by_data_type', JSON.stringify({data_type: data_type}));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  GetDataByDataTypeAndId(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('get_single_data_by_data_type_and_id', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  GetApplicationByPostId(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('get_application_by_post_id', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  GetAllApplicationWithPostTitle(): Promise<any> {
    let body = new URLSearchParams();
    body.set('get_all_application_with_post', JSON.stringify({}));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  GetSingleApplicationByIdWithPostTitle(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('get_single_application_by_id', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  DeleteDataByDataTypeAndId(data_type,id): Promise<any> {
    let body = new URLSearchParams();
    body.set('delete_data_by_data_type_and_id', JSON.stringify({data_type: data_type,id:id}));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  NewJobPost(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('new_post', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }

  UpdateJobPost(data): Promise<any> {
    let body = new URLSearchParams();
    body.set('update_post', JSON.stringify(data));

    return new Promise((resolve, reject) => {
      this.http.post(url, body.toString(), options).subscribe(async data => {
        let temp = data;
        if (temp['result'] == "success") {
          resolve(temp);
        } else if (temp['result'] == "fail") {
          resolve(temp);
        } else if (temp['result'] == "error") {
          reject(temp);
        }
      }),
        async error => {
          return error;
        };
    });
  }


}
